import { SET_USER_PANEL, SET_POINTS_CONVERTION } from './types.js'

export default {
    [SET_USER_PANEL] (state , payload) {
      state.modules = payload
    },
    [SET_POINTS_CONVERTION] (state, payload) {
      state.pointConvertions = payload
    }
}